package gr.tech.GRAttestation.navigation

sealed class SitePage(val route: String) {
    data object Dashboard: SitePage(route = "/")
    data object Login: SitePage(route = "/login")

    data object ForgotPassword: SitePage(route = "/forgot-password")
    data object ResetPassword: SitePage(route = "/reset-password")
    data object FinishRegistration: SitePage(route = "/finish-registration")

    data object TermsConditions: SitePage(route = "/terms-conditions")
    data object PrivacyPolicy: SitePage(route = "/privacy-policy")
}